import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div>
      <Helmet>
        <title>Amazon Garden Services - Contact</title>
      </Helmet>
      <div style={{background: "no-repeat center url(/contact/bg.jpg)", backgroundSize: "cover", position: "relative", paddingTop: "120px", paddingBottom: "120px"}}>
          <h1 className="text-center" style={{color: "#FFF"}}>Contact</h1>
      </div>
      <Container style={{paddingTop: "100px", paddingBottom: "100px"}}>
        <Row>
          <Col>
            <h2 className="section-title text-center" style={{marginBottom: "40px"}}>Contact Information</h2>
            <p className="text-center">Please use the details below to contact us:</p>
            <ul className="list-unstyled text-center">
              <li className="d-block">
                <FontAwesomeIcon icon={faMap} style={{marginRight: '8px'}} /> <p className="d-inline-block mb-0">Amazon Garden Services Ltd, 227a West St, Fareham, Hampshire PO16 0HZ</p>
              </li>
              <li className="d-inline-block" style={{marginRight: '24px'}}>
                <FontAwesomeIcon icon={faEnvelope} style={{marginRight: '8px'}} /> <p className="d-inline-block mb-0"><a href="mailto:info@amazongardenservices.co.uk">info@amazongardenservices.co.uk</a></p>
              </li>
              <li className="d-inline-block">
                <FontAwesomeIcon icon={faPhone} style={{marginRight: '8px'}} /> <p className="d-inline-block mb-0"><a href="tel:07769 358797">07769 358797</a></p>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-4">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2518.83005245389!2d-1.1907153222412614!3d50.8528312716719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487468bc636cb769%3A0xe2fea70417098255!2s227a%20West%20St%2C%20Fareham%20PO16%200HZ!5e0!3m2!1sen!2suk!4v1776434530350!5m2!1sen!2suk" width="100%" height="400" title="Google Maps" frameBorder="0" style={{border:0}} allowFullScreen={false}></iframe>
          </Col>
          <Col md={6} style={{position: "relative"}}>
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </div>
  );
}